module.exports = __webpack_public_path__ + "img/grey_050.31827c3f.png";